import { strFromU8, unzipSync } from "fflate";
import { MAX_PERSHING_ZIP_BYTES } from "./iscaArchive";
import { parseBnyPershingGcus } from "./gcus";

const MAX_GCUS_MEMBER_BYTES = 20 * 1024 * 1024;

export function extractBnyPershingGcusZip(bytes) {
  const archiveBytes = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  if (!archiveBytes.length) throw new Error("The selected GCUS ZIP file is empty.");
  if (archiveBytes.length > MAX_PERSHING_ZIP_BYTES) throw new Error("The selected GCUS ZIP exceeds the 25 MB upload limit.");
  let archive;
  try {
    archive = unzipSync(archiveBytes, {
      filter: (entry) => /(^|\/)\d{6}\.GCUS$/i.test(entry.name)
        && entry.originalSize <= MAX_GCUS_MEMBER_BYTES,
    });
  } catch (error) {
    throw new Error(`Unable to open the Pershing GCUS ZIP file: ${error.message}`);
  }
  const memberNames = Object.keys(archive).filter((name) => /(^|\/)\d{6}\.GCUS$/i.test(name));
  if (!memberNames.length) throw new Error("The ZIP file does not contain a Pershing MMDDYY.GCUS file.");
  if (memberNames.length > 1) throw new Error("The ZIP file contains more than one GCUS file.");
  const memberName = memberNames[0];
  const memberBytes = archive[memberName];
  if (memberBytes.length > MAX_GCUS_MEMBER_BYTES) throw new Error("The GCUS file exceeds the 20 MB limit.");
  const contents = strFromU8(memberBytes);
  return { memberName, memberBytes, contents, parsed: parseBnyPershingGcus(contents) };
}

